import { ErrorHandler, Injector, Injectable } from "@angular/core";
import { ErrorMessageService } from "app/core/error-message.service";
//import { GlobalDataStorageService } from 'app/shared/global-data-storage';
//import { MessageService } from 'app/core/message-service';

/**
 * CustomerError handler permet de centraliser le catch des exceptions non catchees
 */
@Injectable()
export class CustomErrorHandler extends ErrorHandler {
  constructor(private errorMessageService: ErrorMessageService) {
    super();
  }

  handleError(error: Error) {
    this.errorMessageService.notifyCustomError(error);
    super.handleError(error);
  }
}
